import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  closeIcon: {
    position: 'absolute',
    top: 3,
    right: 14,
    color: '#000',
    transform: 'scale(1.1)',
  },
  startAndProgressWrapper: {
    position: 'relative',
    maxWidth: 500,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
    zIndex: 999999,
    padding: '25px 20px',
    border: '1px solid #eaeaea',
    borderRadius: 5,
  },
  title: {
    fontSize: 24,
    fontWeight: 500,
    marginBottom: 50,
  },
  firmwareButton: {
    width: '80%',
    backgroundColor: '#3f51b5',
    color: '#fff',
    borderRadius: 4,
    alignItems: 'center',
    '& .Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.26)',
    },
  },
  updateFirmware: {
    fontSize: '0.875rem',
    letterSpacing: '0.02857em',
  },
  firmwareButtonSummary: {
    '& .MuiAccordionSummary-content': {
      margin: 0,
    },
    minHeight: '40px !important',
  },
  progressWrapper: {
    width: '100%',
    height: 50,
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  firmwarePopup: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: '#fff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 99999,
  },
  updateFirmwareButton: {
    fontSize: 14,
    width: 100,
    height: 40,
    display: 'flex',
    flexDirection: 'column',
    transition: '0.3s all ease-in',
    margin: '0 25px',
  },
  linearProgressWrapper: {
    width: '100%',
    marginBottom: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  firmwareStep: {
    fontSize: 12,
    textTransform: 'capitalize',
    marginBottom: 5,
  },
  firmwareProgress: {
    width: '80%',
    transition: '0.3s all ease-in',
    marginRight: 10,
  },
  progressValue: {
    minWidth: 35,
    transition: '0.3s all ease-in',
    marginBottom: 10,
  },
  sleepTip: {
    width: '80%',
    fontSize: 10,
    marginBottom: 30,
    textAlign: 'center',
  },
  circularProgress: {
    color: '#3f51b5',
    width: '25px !important',
    height: '25px !important',
  },
  doneButton: {
    backgroundColor: 'green',
    '&:hover': {
      backgroundColor: 'green',
      opacity: 0.9,
    },
  },
  '@media (max-width: 860px)': {
    startAndProgressWrapper: {
      border: 'none',
    },
    firmwareTitle: {
      width: '100%',
      textAlign: 'center',
      marginBottom: 10,
    },
    firmwareButton: {
      width: '100%',
    },
    selectWrapper: {
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: 20,
    },
  },
  '@media (max-width: 420px)': {
    firmwareTitle: {
      fontSize: 14,
    },
    updateFirmwareButton: {
      margin: '0 15px 0 0',
    },
  },
}))

export default useStyles
